import { RTM } from "@/qrtc_web_rtm/rtm";
import isElectron from "is-electron";

export const ENVSETTINGKEY = "thisisenvsettingkey";
export const TIMEOUT = 20000;
export const CONTENTTYPE = "application/json;charset=UTF-8";
export const APKNAME = "suhang-meeting-latest.apk";

export const WebLinkStatus="WebLinkStatus"
// 登录后用户信息
export const LOGININFOSTORE = "thisisankeytosavelogininfo";
// 登录后用户Token
export const LOGINTOKEN = "thisisanlocastoragetosavelogintoken";
// 设置的key
export const NORMALSETTINGKEY = "thisisthekeyforsavenormalsettings";
// 当前进入的会议信息
export const METTINGPAGE_SAVED_MEETING_INFO = "thisisakeyforsavemeetinginfo";

export const RTM_APPID = "eNxxUEd1GDqcw6SwMNN3Jy";
export const RTM_TOKEN = "001eJxTYLh3dLv75JhaIxXuxJAknt2r9t028X78cMJPKzOz1uDWb35iDKl+FRWhrimG7i6FyeVmweW+fn7GXpWWtt6pDFqloo+ENRgZGRgZWIAYxGcCk8xgkgVMKjCYp5gbGZuZpiZZWhibWJgaW5qnGqcap1mmmJgZJKWkJHIxGFlYGBmbGBqZGwMAfL8oEw==";
//export const RTM_SERVERURL = "ws://49.232.122.245:8002/";
export const RTM_PUBROOM = "10000000000";
export var CurrParticipant= "" ;
export const SVR_DOMAIN = "https://www.superrtc.com"; // 100ms 良好， 300毫秒 较差,  其他，不正常
export const BAIDU = "https://www.baidu.com";
export const GOOG = "https://www.google.com";

const env = window.localStorage.getItem(ENVSETTINGKEY) || "online";
const istest = env === "test"; // || process.env.NODE_ENV === "development";
let devMode = window.location.hostname.indexOf('localhost') != -1
 //从浏览器端动态获取ip
let mycurrip= window.location.hostname;
const ELECTRON_BASEURL = `https://www.superrtc.com/meetingapi`;
const ELECTRON_WSSERVER = `wss://www.superrtc.com/websocket/`

const lanTest/*内网测试模式*/ = true;
let lanTestServer = "112.72.0.139"
let testServer = "49.232.122.245" //121.36.0.230
//let testServer = "124.71.218.21" // 南大地址

let onlineServer = "49.232.122.245"

const protocol = window.location.protocol;
const hostname = "rtc.callpro.mn";
const port = "";
const origin = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
const hostWithPort = `${hostname}${port ? `:${port}` : ''}`;

function getWebBaseUrl() {
   
  if (istest/*测试模式*/) {
    if (devMode) {
      return lanTest?`http://${lanTestServer}:8200` : `http://${testServer}:8200`;
    } else {
      return `${origin}/meetingapi`;
    }
  } else/*正式模式*/ {
    if (devMode) {
      return lanTest?`http://${lanTestServer}:8200` : `http://${onlineServer}:8200`;
    } else {
      return `${origin}/meetingapi`
    }
  }
}

function getWebWssServer(){
  if (istest/*测试模式*/) {
    if (devMode) {
      return lanTest?`ws://${lanTestServer}:8001/` : `ws://${testServer}:8001/`;
    } else {
      return `wss://${hostWithPort}/websocket/`;
    }
  } else/*正式模式*/ {
    if (devMode) {
      return lanTest?`ws://${lanTestServer}:8001/` : `ws://${onlineServer}:8001/`;
    } else {
      return `wss://${hostWithPort}/websocket/`
    }
  }
 }

 function getRTMServer(){
  if (istest/*测试模式*/) {
    if (devMode) {
      return lanTest?`ws://${lanTestServer}:8002/` : `ws://${testServer}:8002/`;
    } else {
      return `wss://${hostWithPort}/rtm/`;
    }
  } else/*正式模式*/ {
    if (devMode) {
      return lanTest?`ws://${lanTestServer}:8002/` : `ws://${onlineServer}:8002/`;
    } else {
      return `wss://${hostWithPort}/rtm/`
    }
  }
 }

function getBaseUrl(){
  return isElectron() ? ELECTRON_BASEURL:getWebBaseUrl();
}

function getWssServer(){
  return isElectron() ? ELECTRON_WSSERVER:getWebWssServer();
}


// const WEB_BASEURL = istest
//   ? (devMode ? "http://121.36.0.230:8200":`${window.location.origin}/restful4`)
//   : (devMode ? 'http://49.232.122.245:8200':`${window.location.origin}/restful3`);
export const BASEURL = getBaseUrl();
// const WEB_WSSSERVER = istest
// ? (devMode ? 'ws://121.36.0.230:8001/':`wss://${window.location.hostname}/websocket4/`)
// : (devMode ? 'ws://49.232.122.245:8001/':`wss://${window.location.hostname}/websocket3/`);
export const WSSSERVER = getWssServer();

export const RTM_SERVERURL = getRTMServer();

console.log(`server=BaseUrl=${BASEURL} WssServer=${WSSSERVER} RTM_SERVERURL=${RTM_SERVERURL}`);

export const RECORD_SERVER = istest?`http://${testServer}:8019/`:`http://${window.location.hostname}:8019/`;

export const SVR_URL = istest
  ? `https://${testServer}:8001`
  : `https://${testServer}:8001`;

//18611385915 //123456
// 832/562
